export default {
  fontSize: "16px",
  marginBottom: 0
};
